import { memo, useEffect, useState } from "react";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "./ReferenceEntry";
import UCUM from "../dictionaries/UCUM";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const DisplayFromFHIRCodeableReference = ({ codeableReference }) => {
  if (codeableReference) {
    if (Array.isArray(codeableReference) || typeof codeableReference !== "object") {
      return <>[ERROR: CodeableReference data not interpretable.]</>;
    }
    if (codeableReference.concept && !codeableReference.reference) {
      return <DisplayFromFHIRCodeableConcept codeableConcept={codeableReference.concept} />
    }
    if (!codeableReference.concept && codeableReference.reference) {
      return <DisplayFromFHIRReference reference={codeableReference.reference} />
    }
    if (codeableReference.concept && codeableReference.reference) {
      return <><DisplayFromFHIRCodeableConcept codeableConcept={codeableReference.concept} />; <DisplayFromFHIRReference reference={codeableReference.reference} /></>
    }
  } else {
    return <></>
  }
}

const CodeableReferenceEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState,
  allowedValues, valueSet, dataEntryStyle, inTableCell, debug, referencedResourceTypes,
  systemChoices, systemChoicesOpen, startCollapsed, enableCreation, fullResourceState, setSourceJsonState }) => {
  let startingCodeableReference = { "concept": "", "reference": "" };
  if (!startingValue) {
    startingCodeableReference = "";
  } else {
    if (startingValue.extension) { startingCodeableReference.extension = startingValue.extension; }
    if (startingValue.concept) { startingCodeableReference.concept = startingValue.concept; }
    if (startingValue.reference) { startingCodeableReference.reference = startingValue.reference; }
  }
  if (dataEntryStyle === "Age") {
    valueSet = UCUM.age;
  } else if (dataEntryStyle === "Duration") {
    valueSet = UCUM.duration;
  } else if (valueSet === "UCUM") {
    valueSet = UCUM.common;
  }

  const [codeableReferenceState, setCodeableReferenceState] = useState(JSON.parse(JSON.stringify(startingCodeableReference || {})));
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect((() => {
    if (Object.keys(codeableReferenceState).length) {
      let newCodeableReference = {};
      if (codeableReferenceState.extension) { newCodeableReference.extension = codeableReferenceState.extension; }
      if (codeableReferenceState.concept && Object.keys(codeableReferenceState.concept).length) { newCodeableReference.concept = codeableReferenceState.concept; }
      if (codeableReferenceState.reference && Object.keys(codeableReferenceState.reference).length) { newCodeableReference.reference = codeableReferenceState.reference; }
      if (Object.keys(newCodeableReference).length === 0) {
        newCodeableReference = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newCodeableReference } });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [codeableReferenceState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRCodeableReference codeableReference={startingValue} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else {
    return <>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeableConceptEntry elementName='concept' fieldLabel='Concept'
          startingValue={codeableReferenceState.concept || null} setResourceState={setCodeableReferenceState}
          systemChoices={systemChoices} systemChoicesOpen={systemChoicesOpen}
          startCollapsed={startCollapsed}
          dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} valueSet={valueSet} debug={debug} />
        <ReferenceEntry elementName='reference' fieldLabel='Reference'
          enableCreation={enableCreation} inTableCell={inTableCell} startCollapsed={startCollapsed}
          startingValue={codeableReferenceState.reference || null} setResourceState={setCodeableReferenceState}
          referencedResourceTypes={referencedResourceTypes} fullResourceState={fullResourceState}
          setSourceJsonState={setSourceJsonState} />
      </div>
    </>
  }
});

export default CodeableReferenceEntry;
export { DisplayFromFHIRCodeableReference };